import moment from 'moment-timezone';
import {
  FINANCE_SOURCES_REQUEST,
  FINANCE_SOURCES_FAILURE,
  FINANCE_SOURCES_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function financeSourcesRequest() {
  return {
    type: FINANCE_SOURCES_REQUEST,
  };
}

function financeSourcesSuccess(data, token = null) {
  return {
    type: FINANCE_SOURCES_SUCCESS,
    payload: {
      data: data || [],
      token,
    },
  };
}

function financeSourcesError(message) {
  return {
    type: FINANCE_SOURCES_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchFinanceSources(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(financeSourcesRequest());
    if (!fresh) {
      let financeSourcesData = {};
      try {
        financeSourcesData = JSON.parse(getItem(`${config.get('appName')}.financeSources`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !financeSourcesData.data ||
        config.get('version') !== financeSourcesData.version ||
        moment().isAfter(moment(financeSourcesData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(financeSourcesSuccess(financeSourcesData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/finance_sources/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.financeSources`, JSON.stringify({
            data: data || [],
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(financeSourcesSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, financeSourcesError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/financeSources.js